import { createAction, props } from '@ngrx/store';
import { IDropDownList } from '@interfaces';
export const loadCities = createAction('[Cities] Load Cities');
export const loadCitiesSuccess = createAction('[Cities] Load Cities Success', props<{ cities: IDropDownList[] }>());
export const loadCitiesFailure = createAction('[Cities] Load Cities Failure', props<{ error: string }>());
